import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import { settings } from '../../../../../../redux/settings/actions';
import { selectListItems } from '../../../../../../redux/library/selector';
import { lmsChapters } from '../../../../../../redux/lms/collections/chapters/action';
import { selectLMSChaptersListItems } from '../../../../../../redux/lms/collections/chapters/selector';
import { selectLMSenrollmentsListItems, selectLMSenrollmentsQueryItems } from '../../../../../../redux/lms/enrollments/selector';
import EnrollmentComponent from '../components/enollment.component';
import { lmsEnrollments } from '../../../../../../redux/lms/enrollments/action';
import { lmsModules } from '../../../../../../redux/lms/modules/action';

const ManagementLMSenrollment = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const lmsEnrollmentQuery = useSelector(selectLMSenrollmentsQueryItems)
    const lmsEnrollmentsItems = useSelector(selectLMSenrollmentsListItems)
    const lmsChaptersItems = useSelector(selectLMSChaptersListItems)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const libraryData = useSelector(selectListItems)
    const [selectedLmsEnrollment, setSelectedLmsEnrollment] = useState<any>();

    const fetchLMSTopicsQueryById = () => {
        dispatch(lmsEnrollments.query({
            url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/enrollments/query`,
            entity: 'lmsEnrollments',
            jsonData: {
                Context: {},
                Records: [
                    {
                        Id: parmas?.id
                    }
                ]
            }
        })).then(() => {
            setIsQuery(true)
        })
    }

    const handleInnerFormChange: any = (event: any, field: string) => {
        setSelectedLmsEnrollment({ ...selectedLmsEnrollment, [field]: event })
    }

    useEffect(() => {
        dispatch(lmsModules.list({
            url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/modules/fetch`,
            entity: 'lmsModules',
            jsonData: {}
        })).then(() => {
            dispatch(lmsChapters.list({
                url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/chapters/fetch`,
                entity: 'lmsChapters',
                jsonData: {}
            }))
        }).then(() => {
            if (parmas?.id > 0) {
                fetchLMSTopicsQueryById()
                setIsLoading(false)
            } else {
                setIsLoading(false)
            }
        })
    }, []
    )
    useEffect(() => {
        if (isQuery) {
            setSelectedLmsEnrollment(lmsEnrollmentQuery?.result?.items)
        }
    }, [isQuery]
    )
    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        const selectedTopicsData =
        {
            "Id": selectedLmsEnrollment?.Id || 0,
            "EntityTypeName": selectedLmsEnrollment?.EntityTypeName || '',
            "EntityId": selectedLmsEnrollment?.EntityId || '',
            "Status": selectedLmsEnrollment?.Status || '',
            "IsActive": selectedLmsEnrollment?.IsActive || false,

        }
        if (parmas?.id > 0) {
            await dispatch(lmsEnrollments.resetAction({ actionType: 'update' }))
            await dispatch(lmsEnrollments.update({
                url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/enrollments`,
                entity: 'lmsEnrollments',
                jsonData: {
                    Context: {},
                    Records: [
                        selectedTopicsData
                    ]
                }
            })).then(() => {
                back()
            })
        } else {
            await dispatch(lmsEnrollments.resetAction({ actionType: 'create' }))
            await dispatch(lmsEnrollments.create({
                url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/enrollments`,
                entity: 'lmsEnrollments',
                jsonData: {
                    Context: {},
                    Records: [
                        selectedTopicsData
                    ]
                }
            })).then(() => {
                back()
            })
        }
    }

    const back = () => {
        navigate('/management/e-applications/lms/enrollments')
    }


    return (
        <>

            {lmsEnrollmentQuery?.isLoading ? <PageLoader /> :
                <EnrollmentComponent
                    handleInnerFormChange={handleInnerFormChange}
                    selectedLmsEnrollment={selectedLmsEnrollment}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                    EntityType={libraryData?.result?.TopicEntityType}
                    FileType={libraryData?.result?.FileType}
                    Chapterslist={lmsChaptersItems?.result?.items}
                />
            }
        </>
    )
}

export default ManagementLMSenrollment;